import { render, staticRenderFns } from "./SyncAuthorization.vue?vue&type=template&id=481e3289&scoped=true"
import script from "./SyncAuthorization.vue?vue&type=script&lang=js"
export * from "./SyncAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e3289",
  null
  
)

export default component.exports